import { useDispatch } from 'react-redux';
import { fetchProductTiles } from '@client/product/redux/products/tile/redux';
import { bindActionCreators } from '@reduxjs/toolkit';

export const useProductTilesAction = (): typeof fetchProductTiles => {
  const dispatch = useDispatch();

  return bindActionCreators(fetchProductTiles, dispatch);
};
